<div class="min-vh-100 py-4 d-flex align-items-center justify-content-center">
    <div class="d-flex align-items-center justify-content-center flex-column">
        <div class="row">
            <div class="col-12 col-md-6 pe-md-6">
                <div class="left-text">
                    <a class="a--border-off d-flex back-link"
                       tabindex="0"
                       [routerLink]="[routeEntity.Root, routeEntity.Login]"
                       [attr.title]="'app.actions.login' | translate">
                        <mat-icon fontIcon="keyboard_backspace" class="me-2" />
                        {{ 'app.actions.login' | translate }}</a>
                    <h1 class="title">
                        {{ 'auth.recover.page_title' | translate }}
                    </h1>
                    @let text = communicationChannelsText$ | async;
                    @if (text) {
                        <div class="subtitle mb-6">
                            <p>{{ text.message }}</p>
                        </div>
                    }
                </div>
            </div>

            <div class="col-12 col-md-6 ps-md-6">
                <app-recover-form [channels]="communicationChannels$ | async"
                                  [settings]="settings$ | async"
                                  [pending]="pending$ | async"
                                  [error]="error$ | async"
                                  [countryCodes]="countryCodes$ | async"
                                  [defaultCode]="defaultCode$ | async"
                                  [regions]="regions$ | async"
                                  (submitted)="onSubmit($event)" />
            </div>
        </div>
    </div>
</div>
